export const normalizeDbqTextLineEndings = (text) =>
  String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

export const calculateEffectiveLength = (text, charsPerLine) => {
  const normalized = normalizeDbqTextLineEndings(text);
  if (!normalized) return 0;

  const parsedCharsPerLine = Number(charsPerLine);
  if (!Number.isFinite(parsedCharsPerLine) || parsedCharsPerLine <= 0) {
    return normalized.length;
  }

  let effectiveLength = 0;
  let currentLinePosition = 0;

  for (const char of normalized) {
    if (char === '\n') {
      effectiveLength += parsedCharsPerLine - currentLinePosition;
      currentLinePosition = 0;
      continue;
    }

    effectiveLength += 1;
    currentLinePosition = (currentLinePosition + 1) % parsedCharsPerLine;
  }

  return effectiveLength;
};

export const truncateToEffectiveLimit = (text, maxLength, charsPerLine) => {
  const normalized = normalizeDbqTextLineEndings(text);
  const parsedLimit = Number(maxLength);
  if (!normalized) return '';
  if (!Number.isFinite(parsedLimit) || parsedLimit <= 0) return '';

  const parsedCharsPerLine = Number(charsPerLine);
  if (!Number.isFinite(parsedCharsPerLine) || parsedCharsPerLine <= 0) {
    return normalized.slice(0, parsedLimit);
  }

  let effectiveLength = 0;
  let currentLinePosition = 0;

  for (let index = 0; index < normalized.length; index += 1) {
    const char = normalized[index];

    if (char === '\n') {
      const newlineCost = parsedCharsPerLine - currentLinePosition;
      if (effectiveLength + newlineCost > parsedLimit) {
        return normalized.slice(0, index);
      }

      effectiveLength += newlineCost;
      currentLinePosition = 0;
      continue;
    }

    if (effectiveLength + 1 > parsedLimit) {
      return normalized.slice(0, index);
    }

    effectiveLength += 1;
    currentLinePosition = (currentLinePosition + 1) % parsedCharsPerLine;
  }

  return normalized;
};
